import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import PageForm from '../Form';
import { fetchPage, updatePage } from '@resources/Page/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { fetchPage, page, updatePage, visible, onCancel } = props;
	const intl = useIntl();
	useEffect(() => {
		const fetchData = async () => {
			await fetchPage(visible);
		};
		visible && fetchData();
	}, [fetchPage, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updatePage(page._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.page.update',
							defaultMessage:
								'An existing Page entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[page]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.page',
					defaultMessage: 'Update Page',
				})}
			</Title>
			{!isEmpty(page) && (
				<PageForm data={page} onSubmit={handleSubmit} {...props} />
			)}
		</Modal>
	);
};

const mapStateToProps = ({ page }) => {
	return {
		page,
	};
};

export default connect(mapStateToProps, {
	fetchPage,
	updatePage,
})(Update);
